import React, { useState, useEffect } from 'react';
import api from '../api/api';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import Usa from '../assets/UsaFlag.png';
import ToastMessage from '../utils/muitoast';
import { useSelector } from 'react-redux';
import { acessPrivilages, sidebarListItems } from '../utils/sidebarList';
import { useLocation } from 'react-router-dom';
import ConfirmDiscardModal from './discardmodal';

const AddUserModal = ({ isOpen, onClose, onSave, editUser, showToast }) => {
  const [roles, setRoles] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [allDevices, setAllDevices] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
   const [token, setToken] = useState(null);
  const [initialData, setInitialData] = useState(null); // NEW
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [errors, setErrors] = useState({});
  const [countryCode, setCountryCode] = useState('+1');
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
    const location = useLocation();
const [selectedPermissions, setSelectedPermissions] = useState([]);
let adminpermissions=['1','2','3','4','5','6','7','8','9','10','11','12','13','14']
let supervisorpermissions=['1','5','6','2','3','13',]
let projectmanagerpermission=['1','5','6','13']
  const [alertMessage, setAlertMessage] = useState("");
  const hasUnsavedChanges = () => {
  if (!isEditMode || !initialData) return false;
  return JSON.stringify(formData) !== JSON.stringify(initialData);
};

  const user = useSelector((state) => state.user.userDetails);
   useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
      const accessToken = queryParams.get('allow');
   
      if (accessToken) {
        setToken(accessToken);
   
      }

    }, [location.search]);
 console.log(editUser,user)
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    username: '',
    password: '',
    phone: '',
    email: '',
    newPin: '',
    confirmPin: '',
    gender: '',
    status: '',
    role: '',
    ipadids: [''],
    companyid: '',
  });
useEffect(() => {
  // Don't override permissions if editing a user who already has permissions
  if (isEditMode && editUser?.user_info?.permissions?.length > 0) return;

  const selectedRoleObj = roles.find(role => role.id === Number(formData.role));
  const roleName = selectedRoleObj?.role;

  if (roleName === 'Admin') {
    setSelectedPermissions(adminpermissions);
  } else if (roleName === 'Supervisor') {
    setSelectedPermissions(supervisorpermissions);
  } else if (roleName === 'Project Manager') {
    setSelectedPermissions(projectmanagerpermission);
  } else {
    setSelectedPermissions([]);
  }
}, [formData.role, roles, isEditMode, editUser]);


  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      fetchRoles();
      fetchCompanies();
      fetchDevices();
if (editUser) {
  // If permissions already exist for user (previously saved)
  if (editUser?.user_info?.permissions?.length > 0) {
    setSelectedPermissions(editUser.user_info.permissions);
  } 
  // Otherwise auto-select based on their role
  else if (editUser.user_roles?.role === 'Admin' || editUser.role_name === 'Admin') {
    setSelectedPermissions(adminpermissions);
  } else if (editUser.user_roles?.role === 'Supervisor' || editUser.role_name === 'Supervisor') {
    setSelectedPermissions(supervisorpermissions);
  } else if (editUser.user_roles?.role === 'Project Manager' || editUser.role_name === 'Project Manager') {
    setSelectedPermissions(projectmanagerpermission);
  } else {
    setSelectedPermissions([]);
  }
} else {
  setSelectedPermissions([]);
}


      if (editUser) {
        setIsEditMode(true);
        const phone = editUser.phone || '';
        const codeMatch = phone.match(/^(\+\d+)/);
        const code = codeMatch ? codeMatch[1] : '+1';
        setCountryCode(code);

        const updatedForm = {
          firstname: editUser.firstname || '',
          lastname: editUser.lastname || '',
          username: editUser.username,
          password: '',
          phone: phone.replace(/^\+\d+\s?/, ''),
          email: editUser.email || '',
          newPin: '',
          confirmPin: '',
          gender: editUser.gender === 'M' ? 'Male' : editUser.gender === 'F' ? 'Female' : 'Other',
          status: editUser.status === 'A' ? 'Active' : 'Inactive',
          role: editUser.role_id || '',
          ipadids: Array.isArray(editUser.ipadid)
            ? editUser.ipadid.map(id => id.trim())
            : typeof editUser.ipadid === 'string'
              ? editUser.ipadid.split(',').map(id => id.trim())
              : [],
          companyid: editUser.user_role === 'Project Manager'||editUser.user_role === 'Supervisor'
            ? editUser?.user_info?.company_id
            : editUser?.companyid || '',
        };

        setFormData(updatedForm);
        setInitialData(updatedForm); // Save initial data for comparison
      } else {
        setIsEditMode(false);
        const emptyData = {
          firstname: '',
          lastname: '',
          username: '',
          password: '',
          phone: '',
          email: '',
          newPin: '',
          confirmPin: '',
          gender: '',
          status: '',
          role: '',
          ipadids: [''],
          companyid: '',
        };
        setFormData(emptyData);
        setInitialData(null); // Clear
      }

      setErrors({});
    }
  }, [isOpen, editUser]);

  const fetchRoles = async () => {
    try {
      const response = await api.get('/v1/roles', {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      });
      setRoles(response.data);
    } catch (error) {
      console.error('Failed to fetch roles:', error);
    }
  };

  const fetchCompanies = async () => {
    try {
      const response = await api.get(`/v1/timesheets/company-details`);
      if (response.status === 200) {
        setCompanies(response.data);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const fetchDevices = async () => {
    try {
      const response = await api.get("/v1/devices/available");
      if (response.status === 200) {
        setAllDevices(response.data);
      }
    } catch (error) {
      console.error("Error fetching devices:", error);
    }
  };

  const getAvailableDevices = (currentId) => {
    return allDevices.filter(device => {
      const match = device.device_uid.match(/\d+$/);
      if (!match) return false;
      return (
        !formData.ipadids.includes(device.device_uid) ||
        device.device_uid === currentId
      );
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleIpadChange = (index, value) => {
    const updated = [...formData.ipadids];
    updated[index] = value;
    setFormData(prev => ({ ...prev, ipadids: updated }));
  };

  const addIpadField = () => {
    const availableDevices = allDevices.filter(d => !formData.ipadids.includes(d.device_uid));
    if (availableDevices.length > 0) {
      setFormData(prev => ({ ...prev, ipadids: [...prev.ipadids, ''] }));
    }else{
      setSeverity("info");
        setAlertMessage("No Ipads Available");
        setOpen(true);
    }
  };

  const removeIpadField = (index) => {
    const updated = [...formData.ipadids];
    updated.splice(index, 1);
    setFormData(prev => ({ ...prev, ipadids: updated }));
  };

  const validateForm = () => {
  let newErrors = {};

  if (!formData.firstname) newErrors.firstname = 'Firstname is required';
  if (!formData.lastname) newErrors.lastname = 'Lastname is required';
  if (!formData.username) newErrors.username = 'Username is required';

  if (!isEditMode && !formData.password) {
    newErrors.password = 'Password is required';
  } else if (
    formData.password &&
    !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])/.test(formData.password)
  ) {
    newErrors.password = 'Password must be strong';
  }

  if (!formData.phone) {
    newErrors.phone = 'Phone number is required';
  } else if (!/^\d{10}$/.test(formData.phone)) {
    newErrors.phone = 'Phone number must be 10 digits';
  }

  if (!formData.email) {
    newErrors.email = 'Email is required';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    newErrors.email = 'Invalid email address';
  }

  if (!isEditMode && !formData.newPin) {
    newErrors.newPin = 'PIN is required';
  } else if (!isEditMode && formData.newPin.length < 4) {
    newErrors.newPin = 'PIN must be at least 4 digits';
  }

  if (!isEditMode && formData.newPin !== formData.confirmPin) {
    newErrors.confirmPin = 'PINs do not match';
  }

  if (!formData.gender) newErrors.gender = 'Gender is required';
  if (!formData.status) newErrors.status = 'Status is required';
  if (!formData.role) newErrors.role = 'Role is required';

  const selectedRole = roles.find(role => role.id === Number(formData.role));
  if (selectedRole?.role === 'Project Manager' && !formData.companyid) {
    newErrors.companyid = 'Company is required for Project Manager';
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0; // ✅ valid if no errors
};


  const getUpdatedFields = () => {
    if (!initialData) return {}; // fallback

    const updatedFields = {};
    const mapGender = (g) => (g === 'Male' ? 'M' : g === 'Female' ? 'F' : 'O');
    const mapStatus = (s) => (s === 'Active' ? 'A' : 'I');

    Object.keys(initialData).forEach((key) => {
      const current = formData[key];
      const initial = initialData[key];

      if (key === 'gender' && mapGender(current) !== editUser.gender) {
        updatedFields[key] = mapGender(current);
      } else if (key === 'status' && mapStatus(current) !== editUser.status) {
        updatedFields[key] = mapStatus(current);
      } else if (key === 'ipadids') {
        const cleanedCurrent = current.map(id => id.trim()).filter(Boolean);
        const cleanedInitial = initial.map(id => id.trim()).filter(Boolean);
        if (JSON.stringify(cleanedCurrent) !== JSON.stringify(cleanedInitial)) {
          updatedFields.ipadid = cleanedCurrent;
        }
      } else if (key === 'companyid') {
        if (current && current !== initial) {
          updatedFields.user_info = { company_id: current };
        }
      } else if (current !== initial) {
        updatedFields[key] = current;
      }
    });

    if (formData.password) updatedFields.password = formData.password;
    if (formData.newPin) updatedFields.mpin = formData.newPin;

    return updatedFields;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
if(selectedPermissions.length===0){
       setSeverity("info");
        setAlertMessage("Please select Privilages");
        setOpen(true);
  return
}
    try {
   
      let userData;
      if (isEditMode && editUser) {
        userData = getUpdatedFields();
      } else {
        userData = {
          firstname: formData.firstname,
          lastname: formData.lastname,
          username: formData.username,
          password: formData.password,
          mpin: formData.newPin,
          phone: formData.phone,
          email: formData.email,
          gender: formData.gender === 'Male' ? 'M' : formData.gender === 'Female' ? 'F' : 'O',
          status: formData.status === 'Active' ? 'A' : 'I',
          role: formData.role,
          ipadid: formData.ipadids.filter(Boolean),
          ...(formData.companyid && { user_info: { company_id: formData.companyid } }),
        };
      }

      const response = isEditMode
        ? await api.put(`/v1/users/${editUser.id}`, userData)
        : await api.post('/v1/users', userData);

         
    // Only send permissions if user is Admin
    if (user?.user_roles?.role === 'Admin'&&response.status==200) {
         const userId = isEditMode ? editUser.id : response.data.id;
    const oldPermissions = isEditMode 
  ? (editUser.user_info?.permissions || []) 
  : [];

      const newPermissions = selectedPermissions || [];

      // Check if permissions changed
      const permissionsChanged = 
        oldPermissions.length !== newPermissions.length ||
        oldPermissions.some((id) => !newPermissions.includes(id));

      if (permissionsChanged) {
        await api.put(`/v1/users/${userId}/user-info`, {
          permissions: newPermissions,
        });
      }
    }
      if (response.status === 200) {
        onSave(response.data, isEditMode);
        onClose();
        showToast(isEditMode ? 'User updated successfully' : 'User created successfully');
        if(user?.id===editUser?.id){
      window.location.reload();    
        }


      } else {
         if (response.message?.toLowerCase().includes("email")) {
        setErrors(prev => ({ ...prev, email: response.message })); // 🔴 email error
      } else if (response.message?.toLowerCase().includes("phone")) {
        setErrors(prev => ({ ...prev, phone: response.message })); // 🔴 phone error
      } else {
        setSeverity("info");
        setAlertMessage(response?.message || "Something Went Wrong");
        setOpen(true);
      }
      }
    } catch (error) {
      console.error('Failed to save user:', error);
      setSeverity("error");
      setAlertMessage("Something went wrong");
      setOpen(true);
    }
  };
  const isInactive = formData.status === "Inactive" || formData.status === "I";


  const selectedRole = roles.find(role => role.id === Number(formData.role));
useEffect(()=>console.log(selectedRole,'selectedrole'),[selectedRole])
  if (!isOpen) return null;

  return (
<div className="absolute inset-0 bg-black bg-opacity-50 z-50 overflow-y-auto">
  <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl mx-auto my-8 p-6 relative">
        <h2 className='text-xl text-left font-inter font-semibold mb-4'>{isEditMode ? 'Edit User' : 'Add New User'}</h2>

        <form onSubmit={handleSubmit}>
          <div className='grid grid-cols-2 gap-4'>
            {/* Firstname */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Firstname</label>
              <input
                name="firstname"
                value={formData.firstname}
                disabled={isInactive}
                onChange={handleChange}
                className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.firstname ? 'border-red-500' : ''}`}
                placeholder='Firstname'
              />
              {errors.firstname && <p className="text-red-500 text-xs mt-1">{errors.firstname}</p>}
            </div>

            {/* Lastname */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Lastname</label>
              <input
                name="lastname"
                value={formData.lastname}
                disabled={isInactive}
                onChange={handleChange}
                className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.lastname ? 'border-red-500' : ''}`}
                placeholder='Lastname'
              />
              {errors.lastname && <p className="text-red-500 text-xs mt-1">{errors.lastname}</p>}
            </div>

            {/* Username */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Username</label>
              <input
                name="username"
                autoComplete='off'
                value={formData.username}
                onChange={handleChange}
                disabled={isInactive}
                className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.username ? 'border-red-500' : ''}`}
                placeholder='Username'
              />
              {errors.username && <p className="text-red-500 text-xs mt-1">{errors.username}</p>}
            </div>

            {/* Password */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Password</label>
              <input
                type='password'
               autoComplete="new-password"  
                name="password"
                value={formData.password}
                disabled={isInactive}
                onChange={handleChange}
                className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.password ? 'border-red-500' : ''}`}
                placeholder='Password'
              />
              {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password}</p>}
              {/* <p className="text-xs text-gray-500 mt-1">
                Must contain: 8+ chars, 1 uppercase, 1 lowercase, 1 number, 1 special char
              </p> */}
            </div>

            {/* Phone with Country Code */}
            <div>
  <label className='font-Font1 font-semibold text-[15px] flex'>Phone</label>
  <div className="flex">
    <div className="flex items-center justify-center px-3 py-1 border border-r-0 rounded-l bg-gray-50">
    <img src={Usa} className="mr-1" style={{ width: '25px', height: 'auto' }} />
      <span>+1</span>
    </div>
    <input
      name="phone"
      value={formData.phone}
      onChange={handleChange}
      disabled={isInactive}
      className={`w-full border rounded-r px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.phone ? 'border-red-500' : ''}`}
      placeholder='Enter phone number'
    />
  </div>
  {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
</div>

            {/* Email */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Email</label>
              <input
                name="email"
                type="email"
                value={formData.email}
                disabled={isInactive}
                onChange={handleChange}
                className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.email ? 'border-red-500' : ''}`}
                placeholder='Email'
              />
              {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
            </div>
{/* New PIN */}
<div>
  <label className='font-Font1 font-semibold text-[15px] flex'>New PIN</label>
  <input
    name="newPin"
    type="password"
    value={formData.newPin}
    onChange={handleChange}
    maxLength="4"
disabled={isInactive}
    className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.newPin ? 'border-red-500' : ''}`}
    placeholder='4-digit PIN'
  />
  {errors.newPin && <p className="text-red-500 text-xs mt-1">{errors.newPin}</p>}
</div>

{/* Confirm PIN */}
<div>
  <label className='font-Font1 font-semibold text-[15px] flex'>Confirm PIN</label>
  <input
    name="confirmPin"
    type="password"
    value={formData.confirmPin}
    onChange={handleChange}
    maxLength="4"
disabled={isInactive}
    className={`w-full border rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.confirmPin ? 'border-red-500' : ''}`}
    placeholder='Confirm PIN'
  />
  {errors.confirmPin && <p className="text-red-500 text-xs mt-1">{errors.confirmPin}</p>}
</div>


            {/* Gender */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Gender</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                disabled={isInactive}
                className={`w-full border cursor-pointer rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.gender ? 'border-red-500' : ''}`}
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
              {errors.gender && <p className="text-red-500 text-xs mt-1">{errors.gender}</p>}
            </div>

            {/* Status */}
            <div  >
              <label className='font-Font1 font-semibold text-[15px] flex'>Status</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                
                className={`w-full border cursor-pointer rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.status ? 'border-red-500' : ''}`}
              >
                <option value=""> Select Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
              {errors.gender && <p className="text-red-500 text-xs mt-1">{errors.status}</p>}
            </div>

            {/* Role (required) */}
            <div>
              <label className='font-Font1 font-semibold text-[15px] flex'>Roles *</label>
              <select
                name="role"
                value={formData.role}
                disabled={isInactive}
                onChange={handleChange}
                className={`w-full border cursor-pointer rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.role ? 'border-red-500' : ''}`}
              >
                <option value="">Select Role</option>
                {roles.map(role => (
                  <option key={role.id} value={role.id}>
                    {role.role}
                  </option>
                ))}
              </select>
              {errors.role && <p className="text-red-500 text-xs mt-1">{errors.role}</p>}
            </div>

            {/* iPad ID */}
         <div className="col-span-2 mb-4">
          <label className='font-Font1 font-semibold text-[15px] flex mb-1'> Assigned iPad's</label>
          {formData.ipadids.map((id, index) => (
            <div key={index} className="flex items-center mb-2">
      <select
  value={formData.ipadids[index] || ""}
  onChange={(e) => {
    const updatedIpadids = [...formData.ipadids];
    updatedIpadids[index] = e.target.value;
    setFormData({ ...formData, ipadids: updatedIpadids });
  }}
  className="w-full border px-2 py-1 rounded  "
>
  <option value="" disabled>Select iPad</option>

  {/* Always include the current selected value */}
  {formData.ipadids[index] && !allDevices.some(d => d.device_uid === formData.ipadids[index]) && (
    <option value={formData.ipadids[index]}>
      {formData.ipadids[index]} 
    </option>
  )}

  {getAvailableDevices(formData.ipadids[index]).map((device) => (
    <option key={device.device_uid} value={device.device_uid}>
      {device.device_uid}
    </option>
  ))}
</select>




              {formData.ipadids.length > 0 && (
                <button
                  type="button"
                  onClick={() => removeIpadField(index)}
                  className="ml-2 text-red-500 font-bold text-xl"
                >
                  ×
                </button>
              )}
            </div>
          ))}
          <button
            type="button"
            onClick={addIpadField}
            disabled={isInactive}
            className="text-sm text-blue-600 mt-1"
          >
            + Add Another iPad
          </button>
          {errors.ipadids && <p className="text-red-500 text-xs mt-1">{errors.ipadids}</p>}
        </div>
            
            {(selectedRole?.role === 'Project Manager' || selectedRole?.role === 'Supervisor') &&(
              <div>
                <label className='font-Font1 font-semibold text-[15px] flex'>Company ID *</label>
                <select
                  name="companyid"
                  value={formData.companyid}
                  onChange={handleChange}
                  className={`w-full border cursor-pointer rounded px-3 py-1 focus:shadow-[0_0_6px_1px_#145388] focus:outline-none ${errors.companyid ? 'border-red-500' : ''}`}
                >
                  <option value="">Select Company</option>
                  {companies.map(company => (
                    <option key={company.id} value={company.id}>
                      {company.name}
                    </option>
                  ))}
                </select>
                {errors.companyid && <p className="text-red-500 text-xs mt-1">{errors.companyid}</p>}
              </div>
            )}
          </div>
{user?.user_roles?.role === 'Admin' && (
  <div className="col-span-2 mt-4 border-t pt-4">
    {/* Sidebar Privileges */}
    <h3 className="font-semibold text-lg mb-3">Sidebar Privileges</h3>
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mb-6">
      {sidebarListItems(token).map((item) => {
        const isChecked = selectedPermissions.includes(item.id);

        const handleCheckboxChange = () => {
          setSelectedPermissions((prev) =>
            prev.includes(item.id)
              ? prev.filter((id) => id !== item.id)
              : [...prev, item.id]
          );
        };

        return (
          <label
            key={item.id}
            className="flex items-center space-x-2 p-2 border rounded-md hover:bg-gray-100 cursor-pointer"
          >
            <input
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <span>{item.label}</span>
          </label>
        );
      })}
    </div>

    {/* Access Management Section */}
    {acessPrivilages?.length > 0 && (
      <>
        <h3 className="font-semibold text-lg mb-3">Access Management</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {acessPrivilages.map((item) => {
            const isChecked = selectedPermissions.includes(item.id);

            const handleCheckboxChange = () => {
              setSelectedPermissions((prev) =>
                prev.includes(item.id)
                  ? prev.filter((id) => id !== item.id)
                  : [...prev, item.id]
              );
            };

            return (
              <label
                key={item.id}
                className="flex items-center space-x-2 p-2 border rounded-md hover:bg-gray-100 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                <span>{item.label}</span>
              </label>
            );
          })}
        </div>
      </>
    )}
  </div>
)}



          <div className='mt-6 text-right'>
            <button
              type="submit"
              className='bg-red-800 text-white px-4 text-[15px] py-1 font-Font1  rounded hover:bg-red-700'
            >
              {isEditMode ? 'UPDATE' : 'SAVE'}
            </button>
          </div>

        </form>

        <button
          className='absolute top-4 right-4 text-gray-500 hover:text-black text-xl'
          // onClick={onClose}
          onClick={() => {
  if (isEditMode && hasUnsavedChanges()) {
    setShowConfirmModal(true);
  } else {
    onClose();
  }
}}

        >
          <ClearRoundedIcon />
          </button>
      </div>
      <ConfirmDiscardModal
  open={showConfirmModal}
  onCancel={() => setShowConfirmModal(false)}
  onDiscard={() => {
    setShowConfirmModal(false);
    onClose();   // user confirmed close
  }}
/>

        <ToastMessage
              message={alertMessage}
              severity={severity}
              open={open}
              handleClose={handleCloseToast}
            />
    </div>
  );
};

export default AddUserModal;